import styled from "styled-components";

const BlockCellMenu = styled.div(({ theme }) => ({
  cursor: "pointer",
  height: "100%",
  marginRight: 0,
  paddingLeft: "6px",
  paddingRight: "6px",
  paddingTop: theme.sizes.x1,
  width: "100%",
  zIndex: 9,
}));

export default BlockCellMenu;
